import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=983ca6a2"
import script from "./file-upload.vue?vue&type=script&lang=ts"
export * from "./file-upload.vue?vue&type=script&lang=ts"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=983ca6a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports